module.exports = __webpack_public_path__ + "media/חום.bf30c7b8.mp3";